import React from 'react';
import AverageDailyRate from '@/chart/charts/adr-chart';
import BookedRatio from '@/chart/charts/booked-ratio-chart';
import CurrentStrProperties from '@/chart/charts/current-str-properties-chart';
import Occupancy from '@/chart/charts/occupancy-chart';
import OnlinePlatforms from '@/chart/charts/online-platforms-chart';
import RentalSize from '@/chart/charts/rental-size-chart';
import RentalStructure from '@/chart/charts/rental-structure-chart';
import RentalType from '@/chart/charts/rental-type-chart';
import ResidentialType from '@/chart/charts/residential-type-chart';
import Revenue from '@/chart/charts/revenue-chart';
import TransientOccupancyTax from '@/chart/charts/tot-chart';
import { useTransientOccupancyTaxName } from '@/hooks/useTaxName';

/**
 * This file acts as an index file for all charts. Charts should be imported from
 * here always.
 */

// allows for importing single charts if desired
export function CurrentStrPropertiesChart(props) {
  const CurrentStrPropertiesAsChart = CurrentStrProperties(props);
  return <CurrentStrPropertiesAsChart />;
}

export function OccupancyChart(props) {
  const OccupancyAsChart = Occupancy(props);
  return <OccupancyAsChart />;
}

export function RevenueChart(props) {
  const RevenueAsChart = Revenue(props);
  return <RevenueAsChart />;
}

export function AverageDailyRateChart(props) {
  const AverageDailyRateAsChart = AverageDailyRate(props);
  return <AverageDailyRateAsChart />;
}

export function ResidentialTypeChart(props) {
  const ResidentialTypeAsChart = ResidentialType(props);
  return <ResidentialTypeAsChart />;
}

export function UnitTypeChart(props) {
  const UnitTypeAsChart = RentalType(props); // TODO: rename RentalType to UnitType
  return <UnitTypeAsChart />;
}
export function RentalStructureChart(props) {
  const RentalStructureAsChart = RentalStructure(props);
  return <RentalStructureAsChart />;
}

export function RentalSizeChart(props) {
  const RentalSizeAsChart = RentalSize(props);
  return <RentalSizeAsChart />;
}

export function OnlinePlatformsChart(props) {
  const OnlinePlatformsAsChart = OnlinePlatforms(props);
  return <OnlinePlatformsAsChart />;
}

export function BookedRatioChart(props) {
  const BookedRatioAsChart = BookedRatio(props);
  return <BookedRatioAsChart />;
}

export function TransientOccupancyTaxChart(props) {
  const totAlias = useTransientOccupancyTaxName();

  const TOTAsChart = TransientOccupancyTax({ ...props, totAlias });
  return <TOTAsChart />;
}

// Exports mapping between chart name and chart jsx instance
export const CHART_TO_COMPONENT = {
  CURRENT_STR_PROPERTIES: CurrentStrPropertiesChart,
  OCCUPANCY: OccupancyChart,
  REVENUE: RevenueChart,
  AVG_DAILY_RATE: AverageDailyRateChart,
  RESIDENTIAL_TYPE: ResidentialTypeChart,
  RENTAL_STRUCTURE: RentalStructureChart,
  UNIT_TYPE: UnitTypeChart,
  RENTAL_SIZE: RentalSizeChart,
  ONLINE_PLATFORMS: OnlinePlatformsChart,
  BOOKED_RATIO: BookedRatioChart,
  TRANSIENT_OCCUPANCY_TAX: TransientOccupancyTaxChart,
};
